import { render, staticRenderFns } from "./BreadcrumbItem.vue?vue&type=template&id=9704773c"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9704773c')) {
      api.createRecord('9704773c', component.options)
    } else {
      api.reload('9704773c', component.options)
    }
    module.hot.accept("./BreadcrumbItem.vue?vue&type=template&id=9704773c", function () {
      api.rerender('9704773c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Breadcrumb/BreadcrumbItem.vue"
export default component.exports